import {
  DEPARTMENTS_FETCH_FAIL,
  DEPARTMENTS_FETCH_REQUEST,
  DEPARTMENTS_FETCH_SUCCESS,
} from "../constants/DepartmentConstants";
import { getAllDepartments } from "../services/departmentService";

export const fetchDepartments = () => async (dispatch) => {
  dispatch({ type: DEPARTMENTS_FETCH_REQUEST });

  try {
    const data = await getAllDepartments();
    dispatch({ type: DEPARTMENTS_FETCH_SUCCESS, payload: Array.isArray(data) ? data : [] });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    const message =
      error?.response?.data?.message || error?.message || "Failed to fetch departments.";
    dispatch({ type: DEPARTMENTS_FETCH_FAIL, payload: message });
    throw error;
  }
};
